<template>
<div>
 <!-- Hero Start -->
        <section class="bg-half bg-light d-table w-100">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-12 text-center">
                        <div class="title-heading">
                            <h4>Blog Or News</h4>
                            <p class="text-muted para-desc mx-auto mt-3 mb-0">We present and write attractive blog posts</p> 
                            <nav aria-label="breadcrumb" class="d-inline-block mt-4">
                                <ul class="breadcrumb mb-0">
                                    <li class="breadcrumb-item"><a href="index.html">Appdesk</a></li>
                                    <li class="breadcrumb-item active" aria-current="page">Blog</li>
                                </ul>
                            </nav>
                        </div>
                    </div><!--end col-->
                    <div class="home-shape-arrow">
                        <a href="blog.html#blog" class="scroll-down"><i class="mdi mdi-arrow-down arrow-icon bg-light text-dark h5"></i></a>
                    </div>
                </div><!--end row-->
            </div> <!--end container-->
        </section><!--end section-->
        <!-- Hero End -->
        <!-- Start BLog -->
        <section class="section" id="blog">
            <div class="container">
                <div class="row">
                    <div class="col-lg-4 col-md-6 col-12 mb-4 pb-2">
                        <div class="card blog-post border-0 rounded overflow-hidden shadow">
                            <img src="../assets/images/blog/01.jpg" class="img-fluid" alt="missing-image">
                            <div class="card-body p-4">
                                <h5 class="mb-3"><a href="javascript:void(0)" class="text-dark title">Install Tinc and VPN Setup on Debian & Ubuntu</a></h5>
                                <p class="text-muted">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                <a href="blog.html#" class="text-primary h6">Read More <i data-feather="arrow-right" class="fea icon-sm"></i></a>
                            </div>
                        </div>
                    </div><!--end col-->
                    
                    <div class="col-lg-4 col-md-6 col-12 mb-4 pb-2">
                        <div class="card blog-post border-0 rounded overflow-hidden shadow">
                            <img src="../assets/images/blog/02.jpg" class="img-fluid" alt="missing-image">
                            <div class="card-body p-4">
                                <h5 class="mb-3"><a href="javascript:void(0)" class="text-dark title">Responsive & Mobile Design</a></h5>
                                <p class="text-muted">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                <a href="blog.html#" class="text-primary h6">Read More <i data-feather="arrow-right" class="fea icon-sm"></i></a>
                            </div>
                        </div>
                    </div><!--end col-->
                    
                    <div class="col-lg-4 col-md-6 col-12 mb-4 pb-2">
                        <div class="card blog-post border-0 rounded overflow-hidden shadow">
                            <img src="../assets/images/blog/03.jpg" class="img-fluid" alt="missing-image">
                            <div class="card-body p-4">
                                <h5 class="mb-3"><a href="javascript:void(0)" class="text-dark title">Initial Server Configuration & Setup on Debian</a></h5>
                                <p class="text-muted">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                <a href="blog.html#" class="text-primary h6">Read More <i data-feather="arrow-right" class="fea icon-sm"></i></a>
                            </div>
                        </div>
                    </div><!--end col-->
                    
                    <div class="col-lg-4 col-md-6 col-12 mb-4 pb-2">
                        <div class="card blog-post border-0 rounded overflow-hidden shadow">
                            <img src="../assets/images/blog/04.jpg" class="img-fluid" alt="missing-image">
                            <div class="card-body p-4">
                                <h5 class="mb-3"><a href="javascript:void(0)" class="text-dark title">Install Tinc and VPN Setup on Debian & Ubuntu</a></h5>
                                <p class="text-muted">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                <a href="blog.html#" class="text-primary h6">Read More <i data-feather="arrow-right" class="fea icon-sm"></i></a>
                            </div>
                        </div>
                    </div><!--end col-->
                    
                    <div class="col-lg-4 col-md-6 col-12 mb-4 pb-2">
                        <div class="card blog-post border-0 rounded overflow-hidden shadow">
                            <img src="../assets/images/blog/05.jpg" class="img-fluid" alt="missing-image">
                            <div class="card-body p-4">
                                <h5 class="mb-3"><a href="javascript:void(0)" class="text-dark title">Responsive & Mobile Design</a></h5>
                                <p class="text-muted">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                <a href="blog.html#" class="text-primary h6">Read More <i data-feather="arrow-right" class="fea icon-sm"></i></a>
                            </div>
                        </div>
                    </div><!--end col-->
                    
                    <div class="col-lg-4 col-md-6 col-12 mb-4 pb-2">
                        <div class="card blog-post border-0 rounded overflow-hidden shadow">
                            <img src="../assets/images/blog/06.jpg" class="img-fluid" alt="missing-image">
                            <div class="card-body p-4">
                                <h5 class="mb-3"><a href="javascript:void(0)" class="text-dark title">Initial Server Configuration & Setup on Debian</a></h5>
                                <p class="text-muted">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                <a href="blog.html#" class="text-primary h6">Read More <i data-feather="arrow-right" class="fea icon-sm"></i></a>
                            </div>
                        </div>
                    </div><!--end col-->
                    
                    <div class="col-lg-4 col-md-6 col-12 mb-4 pb-2">
                        <div class="card blog-post border-0 rounded overflow-hidden shadow">
                            <img src="../assets/images/blog/07.jpg" class="img-fluid" alt="missing-image">
                            <div class="card-body p-4">
                                <h5 class="mb-3"><a href="javascript:void(0)" class="text-dark title">Install Tinc and VPN Setup on Debian & Ubuntu</a></h5>
                                <p class="text-muted">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                <a href="blog.html#" class="text-primary h6">Read More <i data-feather="arrow-right" class="fea icon-sm"></i></a>
                            </div>
                        </div>
                    </div><!--end col-->

                    <div class="col-12">
                        <ul class="pagination justify-content-center mb-0">
                            <li class="page-item"><a class="page-link" href="javascript:void(0)" aria-label="Previous">Previous</a></li>
                            <li class="page-item active"><a class="page-link" href="javascript:void(0)">1</a></li>
                            <li class="page-item"><a class="page-link" href="javascript:void(0)">2</a></li>
                            <li class="page-item"><a class="page-link" href="javascript:void(0)">3</a></li>
                            <li class="page-item"><a class="page-link" href="javascript:void(0)" aria-label="Next">Next</a></li>
                        </ul>
                    </div><!--end col-->
                </div><!--end row-->
            </div><!--end container-->
        </section><!--end section-->
        <!-- End BLog -->

        <!-- Client Start -->
        <section class="py-4 bg-light">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-2 col-md-2 col-6 text-center py-3">
                        <img src="../assets/images/client/client-01.png" class="avatar avatar-ex-sm partner-img" alt="">
                    </div><!--end col-->

                    <div class="col-lg-2 col-md-2 col-6 text-center py-3">
                        <img src="../assets/images/client/client-02.png" class="avatar avatar-ex-sm partner-img" alt="">
                    </div><!--end col-->
                    
                    <div class="col-lg-2 col-md-2 col-6 text-center py-3">
                        <img src="../assets/images/client/client-03.png" class="avatar avatar-ex-sm partner-img" alt="">
                    </div><!--end col-->
                    
                    <div class="col-lg-2 col-md-2 col-6 text-center py-3">
                        <img src="../assets/images/client/client-04.png" class="avatar avatar-ex-sm partner-img" alt="">
                    </div><!--end col-->
                    
                    <div class="col-lg-2 col-md-2 col-6 text-center py-3">
                        <img src="../assets/images/client/client-05.png" class="avatar avatar-ex-sm partner-img" alt="">
                    </div><!--end col-->
                    
                    <div class="col-lg-2 col-md-2 col-6 text-center py-3">
                        <img src="../assets/images/client/client-06.png" class="avatar avatar-ex-sm partner-img" alt="">
                    </div><!--end col-->
                </div><!--end row-->
            </div><!--end container-->
        </section><!--end section-->
        <!-- Client End -->
</div>
</template>

<script>


export default {
  components: {
  
  }
}
</script>

<style>

</style>
